/**
 * The failure Entra handed back on the last sign-in redirect, if any.
 *
 * Captured at bootstrap rather than read on demand: `handleRedirectPromise()` consumes the response
 * hash and rejects exactly once, so by the time anything renders the reason is gone. Letting that
 * rejection escape aborts bootstrap before the first render and leaves a blank page — which is a
 * miserable thing to debug, since the only trace is a console line and the URL fragment.
 */
let redirectError: string | null = null;

export function setRedirectError(error: unknown): void {
  redirectError = describe(error);
}

export function getRedirectError(): string | null {
  return redirectError;
}

/**
 * MSAL wraps a server refusal in an error carrying the raw AADSTS text, which names the actual
 * problem (a missing scope, an unregistered redirect URI). That text is worth showing verbatim —
 * it is what turns "it does not work" into a specific fix in the portal.
 */
function describe(error: unknown): string {
  if (typeof error === 'string') return error;

  if (error && typeof error === 'object') {
    const candidate = error as { errorMessage?: unknown; message?: unknown; errorCode?: unknown };

    for (const field of [candidate.errorMessage, candidate.message]) {
      if (typeof field === 'string' && field.trim().length > 0) return field;
    }

    if (typeof candidate.errorCode === 'string' && candidate.errorCode.length > 0) {
      return candidate.errorCode;
    }
  }

  return 'Sign-in failed for an unknown reason.';
}
